import React from 'react';

import {withCssModule} from '@pb/kit-util-with-css-module';

import {Tabs} from './tabs.component';
import styles from './tabs.component.module.styl';

import type {TabsProps} from './tabs.component';


const classNames = withCssModule(styles);

/**
 * Second-level tabs styled with the `tabs_s-level` modifier class.
 *
 * Drop-in replacement for `<Tabs>` when a secondary navigation row is needed
 * below the primary tabs. Accepts all `<Tabs>` props.
 */
export const SecondaryTabs = (props: TabsProps) => {
    return <Tabs {...props} rootProps={{className: classNames('tabs_s-level', props.rootProps?.className)}}/>;
};

SecondaryTabs.displayName = 'SecondaryTabs';
